export default "__VITE_ASSET__BMWwiN$J__"